import { API } from 'common/constants/api-urls';
import axios from '../requester';

export const fetchGitTeams = async ({ sensorAuthId, orgName }) => {
  return axios.post(API.SENSOR_GIT_TEAMS, {
    sensor_authorization_id: sensorAuthId,
    org_login: orgName
  });
};

export const fetchGitTeamsDistinctions = async (
  sensorAuthId,
  orgName,
  selectedNodes = []
) => {
  return axios.post(API.SENSOR_GIT_TEAMS_DISTINCTIONS, {
    sensor_authorization_id: sensorAuthId,
    org_login: orgName,
    selected_nodes: selectedNodes
  });
};
